import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { dashboardNavItems } from './DashboardNavItems';
import { AssumedRoleBadge } from '../../features/project/navigation/AssumedRoleBadge';

/*
 * The area (menu group) the current page belongs to. Assumes are scoped
 * per area: the project assume (booking/hosting) only applies inside the
 * 'hosting' area, so its key indicator must not leak into the office
 * ('administration') area. The upcoming partner-scoped office assume
 * will hang off the 'administration' area the same way.
 */
const PROJECT_AREA_GROUP = 'hosting';

/* the active menu item drives both the page title and the current area */
function useActiveNavItem() {
  const { pathname } = useLocation();

  return dashboardNavItems.find((item) => {
    if (!item.to) return false;
    if (pathname === item.to || pathname.startsWith(`${item.to}/`)) {
      return true;
    }
    /* optional wider prefix, e.g. contact-create for the contacts area */
    return item.matchPath && pathname.startsWith(item.matchPath);
  });
}

export function DashboardHeaderLayout() {
  const { t } = useTranslation();
  const activeItem = useActiveNavItem();

  const title = !activeItem
    ? t('dashboard.title')
    : activeItem.labelKey
      ? t(activeItem.labelKey)
      : activeItem.label;
  const inProjectArea = activeItem?.group === PROJECT_AREA_GROUP;

  return (
    <header>
      <h1>{title}</h1>

      {/* the assume indicator only belongs to its own area (see above) */}
      {inProjectArea && <AssumedRoleBadge />}
    </header>
  );
}
